import DOMPurify from 'dompurify'

export const sanitizeProductDescription = (html: string | undefined) => {
  if (!html) {
    return ''
  }

  const sanitized = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['b', 'br'],
    ALLOWED_ATTR: [],
  })

  return sanitized
}

export const sanitizeAndInsertTargetBlank = (html: string | undefined) => {
  if (!html) {
    return ''
  }

  DOMPurify.addHook('uponSanitizeElement', (node, data) => {
    if (data.tagName === 'a') {
      const anchor = node as HTMLAnchorElement
      anchor.setAttribute('target', '_blank')
      anchor.setAttribute('rel', 'noopener noreferrer')

      const href = anchor.getAttribute('href')
      if (href && !/^(https?:\/\/|mailto:|tel:)/i.test(href)) {
        anchor.removeAttribute('href')
      }
    }
  })

  const sanitized = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'a',
      'b',
      'i',
      'u',
      'em',
      'strong',
      'span',
      'br',
      'p',
      'hr',
      'blockquote',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'ul',
      'ol',
      'li',
      'sub',
      'sup',
      'code',
      'pre',
      'table',
      'thead',
      'tbody',
      'tr',
      'td',
      'th',
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel'],
  })

  DOMPurify.removeHook('uponSanitizeElement')

  return sanitized
}
